<template>
    <div class="row align-items-center">
        <div class="col-auto pr-2 mt-1 text-right">
            <a class="btn btn-link p-0" :class="{disabled: (currentAmount == parseInt(availableAmount) || disabledInput == true)}" href="#" @click.prevent="add">
                <i class="material-icons">
                    add_circle
                </i>
            </a>
        </div>
        <div class="col px-0">
            <input class="form-control form-control-sm text-center" :class="{disabled: disabledInput == true}" type="text" name="amount" :value="currentAmount" @input="onInput($event)"/>
        </div>
        <div class="col-auto pl-2 mt-1 text-left">
            <a class="btn btn-link p-0" :class="{disabled: (currentAmount == 1 || disabledInput == true)}" href="#" @click.prevent="remove">
                <i class="material-icons">
                    remove_circle
                </i>
            </a>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      availableAmount: {
        type: String,
        default: '0',
      },
    },
    data () {
      return {
        currentAmount: 1,
        disabledInput: false,
      }
    },

    mounted () {
      if (this.availableAmount == '') {
        this.disabledInput = true
        this.currentAmount = 0
      }
    },

    methods: {

      onInput (event) {
        event.target.value = event.target.value.replace(/\D/, '')

        let vm = this
        if (event.target.value > parseInt(vm.availableAmount)) {
          vm.currentAmount = parseInt(vm.availableAmount)
          event.target.value = vm.currentAmount

          return
        }

        if (parseInt(event.target.value) < 1 || event.target.value == '') {
          vm.currentAmount = 1
          event.target.value = vm.currentAmount

          return
        }

        vm.currentAmount = parseInt(event.target.value)
      },

      add () {
        let vm = this;
        if (vm.currentAmount < parseInt(vm.availableAmount)) {
          vm.currentAmount++;
        }
      },

      remove () {
        let vm = this;
        if (vm.currentAmount > 1) {
          vm.currentAmount--;
        }
      },
    },
  }
</script>

<style scoped>

</style>